import React, { FC } from 'react'
import { StyledNewBlankSection } from './blank-section.styles'

interface BlankSectionProps {
    children: React.ReactNode
    id?: string
}

export const NewBlankSection: FC<BlankSectionProps> = ({ children, id }) => (
    <StyledNewBlankSection id={id} data-testid="search-filter-blank-section">
        {children}
    </StyledNewBlankSection>
)
